module.exports = __webpack_public_path__ + "1c6d2f01fdc0fef19418d3a91faaa4e2.jpg";